export default "__VITE_ASSET__CJ6tk1L4__"